import { render } from "./default-test.vue?vue&type=template&id=40848283&ts=true"
import script from "./default-test.vue?vue&type=script&lang=ts"
export * from "./default-test.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__